export var buildUrl = function (baseUrl, params) {
    if (params === void 0) { params = {}; }
    var url = new URL(baseUrl);
    var sp = new URLSearchParams();
    var _loop_1 = function (key, value) {
        if (value == null)
            return "continue"; // игнорируем null/undefined
        if (Array.isArray(value)) {
            value.forEach(function (v) { return sp.append(key, v); });
        }
        else {
            sp.set(key, String(value)); // приводим к строке
        }
    };
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    url.search = sp.toString();
    return url.href;
};
